import React, { useState, useEffect } from "react";
import { Button } from "../components/ui/button";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale } from "chart.js";
import { FaUserCircle } from "react-icons/fa";
import { Card, CardContent } from "../components/ui/card";
import BalanceCard from "./BalanceCard";
import Menu from './menu';
import axios from '../axiosInstance';
import jwtDecode from "jwt-decode"; // Pour décoder le token JWT
import rollercoinBanner from "../assets/images/bannerRollerCoin.gif"; // Image de bannière RollerCoin
import logoBanner from "../assets/images/new_logo_without_font.png";
import { FaTelegramPlane, FaFacebookF, FaXTwitter } from "react-icons/fa6";
import HighPerformanceAd from "../components/HighPerformanceAd";
import { Sidebar } from "../components/Sidebar";
import { Header } from "../components/Header";
import KpiCards from "../components/KpiCards";


import { Footer } from "../components/ Footer";
// Initialisation des composants ChartJS pour afficher des graphiques
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale);

function Toast({ message, type = "error", onClose }) {
  return (
    <div className={`fixed top-6 left-1/2 transform -translate-x-1/2 z-50 px-4 py-3 rounded shadow-lg text-white ${type === "error" ? "bg-red-600" : "bg-green-600"}`}>
      <div className="flex items-center space-x-2">
        <span>{message}</span>
        <button onClick={onClose} className="ml-2 text-white hover:text-gray-300 font-bold">×</button>
      </div>
    </div>
  );
}



// Composant principal de la page Marketplace
export default function Parameters({ onLogout }) {
  const [options, setOptions] = useState(0); // Options disponibles dans le marketplace
  const [coinz, setCoinz] = useState(0); // Solde en COINZ
  const [selfWeeklyProfit, setSelfWeeklyProfit] = useState(0) // Son propre bénéfice
  const [balance, setBalance] = useState(300); // Solde de l'utilisateur
  const [weeklyProfit, setWeeklyProfit] = useState(0); // Bénéfice hebdomadaire
  const [toast, setToast] = useState({ message: "", type: "" });
  const [message, setMessage] = useState("");
  const [copied, setCopied] = useState(false);
  const [refCode, setRefCode] = useState(""); // Pour afficher le code de parrainage
  const showToast = (message, type = "error") => {
	console.log("test");
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };
    // COPIE : Referal link
  const handleCopyReferral = () => {
	  const link = `${window.location.origin}/register?refer=${refCode}`;
	  navigator.clipboard.writeText(link).then(() => {
		setCopied(true);
		setTimeout(() => setCopied(false), 2000); // Réinitialise après 2 secondes
	  });
 };

	
 // 📡 RÉCUPÉRATION DES DONNÉES UTILISATEUR via l'API
  const getUserData = () => {   

    axios.get(`/api/user/me`,{ withCredentials: true })
      .then((response) => {
        const { coinz, options, systemCoinz, weeklyProfit, lastclaim, ref_code } = response.data;
        const valeurCalculee = options > 0 ? (( systemCoinz / weeklyProfit) * options) : 0;  // On évite la division par 0
		
		setSelfWeeklyProfit(valeurCalculee);
        setCoinz(coinz);
        setOptions(options);
        setWeeklyProfit(weeklyProfit);  
        
		setRefCode(ref_code); // Mise à jour de l'état
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error);
      
      });
  };

  
  // Appeler la fonction au chargement du composant
  useEffect(() => {
    document.title = "Referal | CoinzUp";
	getUserData();
  }, []);
  return (
    <div className="min-h-screen flex flex-col bg-gray-900 text-white font-sans">
      <div className="flex flex-1 min-h-[calc(100vh-64px)]">
        <Sidebar onLogout={onLogout}/>
  
        <main className="flex-1 px-4 sm:px-10 py-8 space-y-10 overflow-auto min-w-0">
        <Header title="Referral programm"  balance={coinz}        optionsOwned={options}        estimatedWeeklyGain={selfWeeklyProfit} />
  
          {/* Toast */}
          {toast.message && (
            <Toast
              message={toast.message}
              type={toast.type}
              onClose={() => setToast({ message: "", type: "" })}
            />
          )}
  
          {/* Ad haut */}
          <HighPerformanceAd
            keyId="fd5da3543c594f07b73630f461f10613"
            width={728}
            height={90}
          />
  
          {/* Referral Program Description */}
          <Card className="bg-gray-900 border border-gray-700 shadow-sm">
            <CardContent className="py-6 space-y-4">
              <h1 className="text-2xl font-bold text-yellow-400">🤝 Referral Program</h1>
              <p className="text-gray-300 text-sm">
                Invite your friends and earn passive rewards from their activity!
              </p>
              <ul className="list-disc pl-5 text-sm text-gray-200 space-y-2">
                <li> <strong>5% of all hourly draw earnings</strong> from your referrals</li>
                <li> <strong>5% of every ad purchase</strong> they make</li>
                <li> <strong>5% of autosurf session</strong></li>
                <li> <strong>50% of PTP promotion</strong></li>
                <li> <strong>+1 option per referral</strong></li>
              </ul>
            </CardContent>
          </Card> 
          
  
          {/* Referral Link */}
          <Card className="bg-gray-900 border border-gray-700 shadow-sm">
            <CardContent className="py-6 space-y-3">
              <h2 className="text-lg font-semibold text-white">My Referral Link</h2>
              <p className="text-gray-300 text-sm">
                Share this link to invite your friends:
              </p>
              <div className="flex flex-col md:flex-row md:items-center gap-2">
                <div className="bg-gray-800 rounded px-4 py-2 text-blue-400 break-all text-sm flex-1">
                  {`${window.location.origin}/register?refer=${refCode}`}
                </div>
                <Button
                  onClick={handleCopyReferral}
                  className="bg-blue-600 hover:bg-blue-700 text-white text-sm"
                >
                  {copied ? "Copied ✅" : "Copy"}
                </Button>
              </div>
            </CardContent>
          </Card>
  
          {/* Ad bas */}
          <HighPerformanceAd
            keyId="96e99453a24be0353f2fe26dc0b9b728"
            width={468}
            height={60}
          />
        </main>
      </div>
  
      <Footer />
    </div>
  );
  
}
